import qs from 'utils/queryString';

const getImage = (filename, params) => {
  const values = params && Object.keys(params).length > 0 ? `?${qs(params)}` : '';
  return `/api/v2/image/${filename}${values}`;
};

export default getImage;
